import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link", "address", "radio-online", "radio-offline"]

  toggleLinkAddress(event) {
    if (event.target.value === "online") {
      this.linkTarget.style.display = "block"
      this.addressTarget.style.display = "none"
    } else if (event.target.value === "in_person") {
      this.linkTarget.style.display = "none"
      this.addressTarget.style.display = "block"
    }
  }
}
